<template>
   <div class="ratings" @mouseleave="hovered = false" v-if="mounted">
      <div :class="['rating-block', { hovered }]">
         <template v-for="(star, i) in Array(range)" >
            <IconStarFilled
               class="rating"
               :class="{ 'rating-fill': i + 1 <= count }"
               @click="updateRating(i + 1)"
               @mouseenter="hovered = i + 1"
            />
         </template>
      </div>
      <slot name="ratingLabel">
         <p class="label">Rate &amp; Comment</p>
      </slot>
   </div>
</template>

<script setup lang="ts">
import IconStarFilled from "~/assets/images/icons/star-filled.svg?component";
const { review} = useTeachable();

const emit = defineEmits(["saveRating"]);
const props = defineProps({
   range: {
      type: Number,
      default: 5,
   },
});
const hovered = ref(false);
const mounted = ref(false);
const count = computed(() =>
   hovered.value ? hovered.value : review.value?.rating ?? 0
);

const updateRating = (newRating) => {
   hovered.value = false;
   emit("saveRating", newRating);
};
onMounted(() => {
   mounted.value = true;
});
</script>
